import React  , { Component } from 'react'
import { withRouter} from 'react-router-dom'
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'
import Loader from '../../Components/Loader/Loader'

import {  shuffle,
                compareDates } from '../../Utility/Utility'
import {  showsArr } from '../../Data/Data'
import {  Img,
          HomeTitle,
          ResponsiveYouTubeIframe,
          HomeDeals,
          ConcertSliderItem } from '../../Components/UI/UI'

import "../Posts.css"
import { ShowsPostsData } from "../PostsData"
class ConcertsPosts extends Component {
  state = {
    id:this.props.match.params.id,

  } 


  componentWillMount() {
  

  }

  componentDidMount (){
 

  }

  componentWillReceiveProps(nextProps) {
   
  }

  render(){
    let counter = 0;
    let currDate = new Date();
    const videosHtml = shuffle( showsArr ).map( (o,i) => {
          let cssClass = '';
          const isTodayBigger = compareDates(currDate, o.date);
          counter++
          if ( counter <= 3 && !isTodayBigger === true ) {

            const url = "/Posts/Concerts/" + o.id ;
            if ( url === "/Posts/Concerts/undefined"){
               cssClass ="no-inner-page";
            }
            return <ConcertSliderItem  
                    key={i}
                    title={o.title}
                    desc={o.date}
                    img= {o.img}
                    link={url} 
                    cssClass={cssClass}

                    />

          }else {
            counter--
          }
                 
    });
    
   
    const current = ShowsPostsData.find(( o ) => {
      return o.id == this.props.match.params.id
    });
   
    let html = null;
    if ( current != undefined ){
      html = <div className={'inner-post post post-type-Concerts inner-post-' + current.id }>
        <Menu />
        <section className="post-data">
           <div className="main-post-banner">
             <Img desktopImg={current.bgImage} 
                  mobileImg={current.mobBgImage} />
              <div className="container align-center white">
                <h1 className="page-section-big-title">
                 {current.title}
                </h1>
              </div>
            </div>
            <div className="container content-container">
              <div className="col col-75">
                <div className="inner"> 
                  <div className="clear"></div>
                  <div className="html-wrapper" dangerouslySetInnerHTML={current.html()} ></div>
                  <div className="clear"></div>
                  <HomeDeals />
                </div>
              </div>
              <div className="col col-25 sidebar">
                <div className="inner">
                  <HomeTitle>
                      VIVIR EN ISRAEL
                  </HomeTitle>
                  {videosHtml}
                </div>
              </div>
              <div className="clear"></div>
            </div>
        </section>
        <Footer />
      </div>
    }
 
    return(html)
  }

}



export default withRouter(ConcertsPosts)


// WEBPACK FOOTER //
// ./src/Posts/Concerts/Concerts.js